// http://idangero.us/swiper/api/#custom-build

import {
    Swiper,
    Virtual,
    Keyboard,
    Mousewheel,
    Navigation,
    Pagination,
    Scrollbar,
    Parallax,
    Zoom,
    Lazy,
    Controller,
    A11y,
    History,
    HashNavigation,
    Autoplay,
    EffectFade,
    EffectFlip,
    EffectCoverflow
} from "swiper/dist/js/swiper.esm.js";

Swiper.use([Mousewheel, Navigation, Pagination, Lazy, Autoplay]);

export default Swiper;
